import dayjs from 'dayjs';

export const sortHoursAscending = (hours: (string | null)[]) =>
  [...hours].sort((a, b) => (dayjs(a, 'HH:mm').toDate() > dayjs(b, 'HH:mm').toDate() ? 1 : -1));
